import { Alert, Button, Stack, Typography, FormControl, InputLabel, Select, MenuItem, useTheme } from '@mui/material';
import { Field } from 'mobx-react-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { observer } from 'mobx-react-lite';
import { NotificationSettingsStore } from 'stores/users/NotificationSettingsStore';
import { emailNotificationsOptions } from 'utils/options';

type NotificationSettingsProps = {
  notificationSettingsStore: NotificationSettingsStore;
};

const NotificationSettings = observer(({ notificationSettingsStore }: NotificationSettingsProps) => {
  const { form, message, status, changeNotificationSettings } = notificationSettingsStore;
  const theme = useTheme();
  const emailNotificationsField: Field = form.$('emailNotifications');

  return (
    <div aria-label="user profile page" style={{ width: 400, marginTop: 60, marginBottom: 30 }}>
      <form autoComplete="off">
        <Stack spacing={4}>
          <Typography variant="h5">
            <strong>Notification Settings</strong>
          </Typography>
          {message && (
            <Alert aria-label="form-error" severity={status === 'error' ? 'error' : 'success'}>
              {message}
            </Alert>
          )}
          <FormControl fullWidth>
            <InputLabel id="email-notifications-label">Email Notifications</InputLabel>
            <Select
              id="email-notifications-select"
              label="Email Notifications"
              size="medium"
              IconComponent={ExpandMoreIcon}
              sx={{
                borderRadius: '4px',
                background: `${theme.palette.background.paper}`,
                textAlign: 'center',
                textTransform: 'uppercase',
                color: `${theme.palette.primary.main}`,
                fontWeight: 'bold',
                '& .MuiSelect-icon': {
                  color: `${theme.palette.primary.main}`,
                },
              }}
              value={emailNotificationsField.value}
              onChange={(event) => {
                emailNotificationsField.onChange(event.target.value);
              }}
            >
              {Object.values(emailNotificationsOptions).map((value) => {
                return (
                  <MenuItem value={value} sx={{ display: 'flex', justifyContent: 'center' }}>
                    {value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            disableElevation
            style={{ height: 56 }}
            disabled={!form.isValid}
            onClick={() => changeNotificationSettings()}
          >
            Save Changes
          </Button>
        </Stack>
      </form>
    </div>
  );
});

export { NotificationSettings };
